function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rosa': 'rgb(213, 189, 229)','beige': 'rgb(243, 232, 216)','hellblau': 'rgb(211, 170, 170)','violett': 'rgb(179, 159, 205)','weiss': 'rgb(255, 255, 255)','lila': 'rgb(220, 213, 217)','rot': 'rgb(255, 0, 0)','grun': 'rgb(0, 128, 0)','blau': 'rgb(81, 123, 173)','schwarz': 'rgb(0, 0, 0)','dunkelblau': 'rgb(0, 0, 139)','dunkelbraun': 'rgb(76, 42, 18)','hellbraun': 'rgb(180, 125, 73)','gelb': 'rgb(255, 255, 0)','marineblau': 'rgb(0, 0, 139)','rot-schwarz': 'rgb(255, 0, 0)','schwarz-rot': 'rgb(0, 0, 0)','schwarz-weiss': 'rgb(255, 255, 255)','schwarz-gold': 'rgb(255, 215, 0)','hellgrun': 'rgb(152, 251, 152)','olivgrun': 'rgb(128, 128, 0)','gelb': 'rgb(252, 252, 64)','blau-schwarz': 'rgb(81, 123, 173)','grau-schwarz': 'rgb(128, 128, 128)','weiss-schwarz': 'rgb(255, 255, 255)','beige': 'rgb(245, 245, 220)','grau': 'rgb(128, 128, 128)','oranje': 'rgb(255, 165, 0)','weinrot': 'rgb(128, 0, 0)','khaki': 'rgb(240, 230, 140)','olivgrun': 'rgb(80, 83, 60)','off-white': 'rgb(250, 249, 246)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
